// Переводы англоязычных enum-значений из API в русские подписи для UI.

const CALL_DIRECTION_LABELS = {
  training_center: 'Учебный центр',
  product_sales: 'Продукты',
  clinic_patient: 'Клиника',
  no_answer_or_technical: 'Недозвон или технический звонок',
  unknown: 'Не определено',
  incoming: 'Входящий',
  inbound: 'Входящий',
  outgoing: 'Исходящий',
  outbound: 'Исходящий',
  internal: 'Внутренний'
};

export const formatCallDirection = (value) => {
  if (!value) return '—';
  return CALL_DIRECTION_LABELS[String(value).trim().toLowerCase()] ?? value;
};

const NEGATIVE_SEVERITY_LABELS = {
  no: 'Нет',
  none: 'Нет',
  mild: 'Умеренный',
  hard: 'Жёсткий'
};

export const formatNegativeSeverity = (value) => {
  if (!value) return '';
  return NEGATIVE_SEVERITY_LABELS[String(value).trim().toLowerCase()] ?? value;
};

// Статусы заказов приходят в исходном виде из API доставки.
const ORDER_STATUS_LABELS = {
  unconfirmed: 'Не подтверждён',
  waitcooking: 'Ожидает приготовления',
  readyforcooking: 'Готов к приготовлению',
  cookingstarted: 'Готовится',
  cookingcompleted: 'Приготовлен',
  waiting: 'Ожидает',
  onway: 'В пути',
  delivered: 'Доставлен',
  closed: 'Закрыт',
  cancelled: 'Отменён'
};

export const formatOrderStatus = (value) => {
  if (!value) return '';
  return ORDER_STATUS_LABELS[String(value).trim().toLowerCase()] ?? value;
};
